// extracted by mini-css-extract-plugin
export var cardContainer = "_p0-0";
export var cardHeader = "_p0-2";
export var collapsedState = "_p0-3";
export var dragHandle = "_p0-5";
export var dragHandleIcon = "_p0-6";
export var dragging = "_p0-1";
export var titleArea = "_p0-4";